import { FieldViewModel, ICropping, isFieldViewModel } from "../../fields"
import { getDateRangeDescr } from "../../utils/date"
import { IDomItem, ITimelineCtrl } from "./types"

export class DomItem implements IDomItem<FieldViewModel> {

    private readonly _id: string

    private _invalidDates = false
    startDate: Date
    endDate: Date

    left: number;
    top: number;
    width: number;
    height: number;

    rank: number
    rowIndex: number
    rowSpan: number

    color: string;
    style: any;

    uncropped: boolean;

    private _mouseOver: boolean;
    selected: boolean;

    tabindex: number;

    continuousPrev: boolean;
    continuousNext: boolean;

    readonly disabled: boolean

    constructor(private readonly tl: ITimelineCtrl, public vm: FieldViewModel, public fieldDomItem: DomItem) {
        this._id = "tl-item-" + vm.getId()
        this.disabled = vm.disabled
        this._invalidDates = checkInvalidDates(vm.cropping)
    }

    get target() {
        return this.vm
    }

    get fieldId() {
        return this.vm.fieldId
    }

    get cropingId() {
        return this.vm.croppingId
    }

    isField() {
        return this.vm.isField()
    }

    isCropping() {
        return this.vm.isCropping()
    }

    getDebugInfo() {

        const vm = this.vm

        return JSON.stringify({
            croppingId: vm.croppingId,
            year: vm.yearId,
            dates: this.getTooltipDates(),
            next: vm.cropping.NextIds,
            prev: vm.cropping.PreviousIds
        })

    }

    getTooltip(debug = false) {

        return debug
            ? this.getDebugInfo()
            : this.getTooltipDates()

    }

    getTooltipDates() {
        const { vm } = this
        const { cropping } = vm
        const start = cropping?.SowingDate || vm.startDate
        const end = cropping?.HarvestDate || cropping?.DestructionDate || vm.endDate
        return getDateRangeDescr(start, end)
    }

    getDescription(short: boolean, debug?: boolean): string {

        let t: string = ""

        const vm = this.vm;

        if (vm) {

            if (debug) {
                t += `(#${vm.croppingId}) - `
            }

            if (vm.cropping.Variety) {
                t += vm.cropping.Variety.Name
                if (!short) t += " - " + vm.getCropName()
            }
            else {
                t += vm.getCropName()
            }

            if (!short) {
                t += " (" + vm.cropping.Area + " ha)"
            }

            if ((!short) && vm.cropping.Crop && vm.cropping.Crop.Perennial) {
                t += " - " + vm.cropping.YearId
            }

            return t;

        }

    }

    get cssClass(): string {

        var cc = this.id;

        if (this.tl.isItemFiltered(this)) {
            cc += " filtered";
        }

        if (this.highlight) {
            cc += " hover";
        }

        if (this.selected) {
            cc += " selected";
        }

        if (!this.tl.canSelectItem(this)) {
            cc += " unselectable";
        }

        if (this.height <= 18) {
            cc += " xxs-size";
        }
        else if (this.height <= 25) {
            cc += " xs-size";
        }
        else if (this.height <= 35) {
            cc += " sm-size";
        }

        if (this.disabled) {
            cc += " disabled";
        }

        return cc;

    }

    get id(): string {
        return this._id;
    }

    get mouseOver(): boolean {
        return this._mouseOver;
    }

    set mouseOver(value: boolean) {

        this._mouseOver = value

        if (this.fieldDomItem) {
            this.fieldDomItem.mouseOver = value
        }

        if ((!this.tl.isEditing()) && this.vm.isCropping()) {
            this.tl.setCurrentCropping(this)
        }


    }

    get highlight(): boolean {

        if (this.tl.isEditing()) return this.selected
        if (this.tl.isDragging) return false
        if (this._mouseOver) return true

        const ctxt = this.tl.popupContext

        if (ctxt && isFieldViewModel(ctxt.target)) {
            if (ctxt.target == this.vm) return true
            if (ctxt.target.fieldVm == this.vm) return true
        }

    }

    hasInvalidDates() {

        if (this._invalidDates) return true
        if (!this.isCropping()) return false

        const { startDate, endDate } = this
        return (startDate >= endDate)

    }

}


function checkInvalidDates(cropping: ICropping) {

    if (cropping) {

        if (cropping.NextCroppings && cropping.NextCroppings.some(c => c.StartDate < cropping.EndDate)) {
            return true
        }

        if (cropping.PreviousCroppings && cropping.PreviousCroppings.some(c => c.EndDate > cropping.StartDate)) {
            return true
        }

    }

}
